module.exports = __webpack_public_path__ + "img/text-input.b42a692e.svg";